import { combineReducers } from 'redux';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { LocalCacheHandler } from '~/utils/local-cache-handler';
import * as ACTIONS from './actions';
import moment from 'moment';

import columnsReducer from './reducers/columnsReducer';
import { drawerReducer, summaryDrawerReducer } from './reducers/drawerReducer';

// Inline loadingReducer
const isLoading = (state = true, action) => {
  switch (action.type) {
    case ACTIONS.LOAD.SUCCESS:
      return false;
    case ACTIONS.LOAD.INIT:
      return true;
    default:
      return state;
  }
};

// Cadence summary reducer for landing page
const cadenceSummaryReducer = (state = { data: [], isLoading: false }, action) => {
  switch (action.type) {
    case ACTIONS.LOAD_CADENCE_SUMMARY.INIT:
      return {
        data: state.data,
        isLoading: true
      };
    case ACTIONS.LOAD_CADENCE_SUMMARY.SUCCESS:
      var responseData = action.payload && action.payload.data && action.payload.data.data;
      return {
        data: responseData || [],
        isLoading: false
      };
    case ACTIONS.LOAD_CADENCE_SUMMARY.FAILURE:
      return {
        data: state.data,
        isLoading: false
      };
    default:
      return state;
  }
};

// Cadence detailed summary reducer
const cadenceDetailedSummaryReducer = (state = { data: null, isLoading: false }, action) => {
  switch (action.type) {
    case ACTIONS.LOAD_CADENCE_DETAILED_SUMMARY.INIT:
      return {
        data: state.data,
        isLoading: true
      };
    case ACTIONS.LOAD_CADENCE_DETAILED_SUMMARY.SUCCESS:
      var detailedData = action.payload && action.payload.data && action.payload.data.data;
      return {
        data: detailedData || null,
        isLoading: false
      };
    case ACTIONS.LOAD_CADENCE_DETAILED_SUMMARY.FAILURE:
      return {
        data: state.data,
        isLoading: false
      };
    default:
      return state;
  }
};

// Flag to trigger summary refresh
const shouldRefreshSummaryReducer = (state = false, action) => {
  switch (action.type) {
    case ACTIONS.BATCH.SUCCESS:
    case ACTIONS.MOVE.SUCCESS:
    case ACTIONS.DELETE.SUCCESS:
    case ACTIONS.CREATE.SUCCESS:
    case ACTIONS.SAVE.SUCCESS:
      return true;
    case ACTIONS.LOAD_CADENCE_DETAILED_SUMMARY.SUCCESS:
      return false;
    default:
      return state;
  }
};

const prospectingReducer = combineReducers({
  columns: columnsReducer,
  drawer: drawerReducer,
  summaryDrawer: summaryDrawerReducer,
  isLoading,
  cadenceSummary: cadenceSummaryReducer,
  cadenceDetailedSummary: cadenceDetailedSummaryReducer,
  shouldRefreshSummary: shouldRefreshSummaryReducer,
  selectedMonth: (state, action) => {
    // Default state for selectedMonth (now using daily format as default)
    const defaultState = moment().format("YYYY-MM-DD");

    // Ensure we have a valid state
    const currentState = state !== undefined ? state : defaultState;
    
    try {
      switch (action.type) {
        case ACTIONS.SET_DATE:
          return action.payload.date;
        default:
          return currentState;
      }
    } catch (error) {
      console.error('Error in selectedMonth reducer:', error);
      return defaultState;
    }
  },
});

const reducer = (state, action) => {
  // Ensure we have a default state
  const defaultState = {
    columns: [],
    drawer: { data: { id: null }, show: false },
    summaryDrawer: { summaryData: null, leads: [], show: false, isLoading: false },
    isLoading: true,
    cadenceSummary: { data: [], isLoading: false },
    cadenceDetailedSummary: { data: null, isLoading: false },
    shouldRefreshSummary: false,
    selectedMonth: moment().format("YYYY-MM-DD")
  };
  
  const currentState = state || defaultState;
  
  if (action.type === CACHE_ACTIONS.prospecting) {
    return action.payload;
  }

  const newState = prospectingReducer(currentState, action);
  
  // Update cache for relevant actions
  const updateCache = [
    ACTIONS.LOAD.SUCCESS,
    ACTIONS.MOVE.SUCCESS,
    ACTIONS.CREATE.SUCCESS,
    ACTIONS.BATCH.SUCCESS,
    ACTIONS.SAVE.SUCCESS,
    ACTIONS.DELETE.SUCCESS,
    ACTIONS.SHOW,
    ACTIONS.CLOSE,
    ACTIONS.SHOW_SUMMARY_DRAWER,
    ACTIONS.CLOSE_SUMMARY_DRAWER
  ].includes(action.type);

  if (updateCache) {
    LocalCacheHandler.save({
      pathname: CACHE_ACTIONS.prospecting,
      data: newState
    });
  }

  return newState;
};

export default reducer;